<ng-select [items]="technicians" autofocus bindLabel="name" bindValue="id" [virtualScroll]="true"
     placeholder="{{_placeholder}}" [(ngModel)]="technicianId" (ngModelChange)="technicianChanged()" [selectOnTab]="true">
</ng-select>
